<div class="edoc-added-banner" data-cy="companionCertificationAlertBanner">
  <div class="edoc-added-banner-wrapper">
    <ng-container>
      <h3 class="labelHeading">
        {{ config.companionCertificateLabel }}
      </h3>
    </ng-container>
    <div class="edoc-added-banner-content">
      <div
        [innerHTML]="config.edocBookingMessagesLabel"
        class="edoc-added-banner-intro"
      ></div>
    </div>
  </div>
</div>
